module.exports = __webpack_public_path__ + "img/charcoal_tweed.a19ecba5.jpeg";